import { Link, useParams } from 'react-router-dom';

import { ContactPanel } from '../../components/dialogs/ContactPanel';
import { DialogConversation } from '../../components/dialogs/DialogConversation';
import { Skeleton } from '../../components/ui/skeleton';
import { useDialog, useSubscribeChannels } from '../../hooks/use-dialogs';

/**
 * Standalone dialog page — kept working for deep links (e.g. from Telegram alerts, §U1 item 1)
 * even though the everyday flow is the two-pane inbox at /inbox/:dialogId.
 */
export function DialogPage() {
  const { id } = useParams<{ id: string }>();
  const dialogQuery = useDialog(id);

  useSubscribeChannels(dialogQuery.data ? [dialogQuery.data.channelId] : []);

  if (dialogQuery.isLoading) {
    return (
      <div className="flex h-full flex-col gap-2 p-4">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-full w-full" />
      </div>
    );
  }

  if (dialogQuery.isError || !dialogQuery.data) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2">
        <p className="text-sm text-red-600">Диалог не найден.</p>
        <Link to="/inbox" className="text-sm text-primary hover:underline">
          Назад в инбокс
        </Link>
      </div>
    );
  }

  const dialog = dialogQuery.data;

  return (
    <div className="flex h-full">
      <DialogConversation
        dialog={dialog}
        headerLeft={
          <Link to="/inbox" className="text-sm text-primary hover:underline">
            ← Инбокс
          </Link>
        }
      />
      <ContactPanel dialog={dialog} />
    </div>
  );
}
